import { defineComponent as a, ref as d, computed as s, openBlock as n, createElementBlock as c, normalizeClass as l, renderSlot as p } from "vue";
import { _ as u } from "./_plugin-vue_export-helper-CHgC5LLL.mjs";
var o = /* @__PURE__ */ ((e) => (e.L = "l", e.M = "m", e.None = "none", e))(o || {});
const i = [
  // Layout
  "layout-column",
  // Shape
  "rounded-md",
  // Spacing
  "gap-[10px]",
  // Typography
  "typography-body-2-regular",
  // Theme
  "theme-background-default dark:theme-background-default-dark",
  "shadow-card dark:shadow-card-dark"
], m = {
  [o.None]: [],
  [o.L]: [
    "p-lg"
  ],
  [o.M]: [
    "p-md"
  ]
}, f = [
  // Hover
  "hover:shadow-contextual hover:dark:shadow-contextual-dark",
  // Selected
  "selected:bg-primary-opacity-0-08 dark:selected:bg-primary-opacity-0-08-dark",
  "selected:shadow-card selected:dark:shadow-card-dark"
], k = a({
  name: "OrCard",
  props: {
    selected: {
      type: Boolean,
      default: !1
    },
    padding: {
      type: String,
      default: () => o.M
    },
    interactive: {
      type: Boolean,
      default: !1
    }
  },
  expose: [
    "root"
  ],
  setup(e) {
    const t = d(), r = s(() => [
      "or-card-v3",
      ...i,
      ...m[e.padding],
      ...e.interactive ? f : []
    ]);
    return {
      root: t,
      rootStyles: r
    };
  }
}), h = ["selected"];
function y(e, t, r, g, v, _) {
  return n(), c("div", {
    ref: "root",
    class: l(e.rootStyles),
    selected: e.selected
  }, [
    p(e.$slots, "default")
  ], 10, h);
}
const b = /* @__PURE__ */ u(k, [["render", y]]);
export {
  o as C,
  b as O
};
//# sourceMappingURL=OrCard-7awJu_df.mjs.map
